// src/components/ThemeToggle.jsx
//
// Topbar shortcut for the portal appearance (light/dark) preference that
// otherwise lives only on the Settings page. Persists through the same
// endpoints Settings uses, so the two stay in sync. Desktop only — the
// .topbar-theme-toggle rule in index.css hides it below 768px.

import React, { useState } from 'react';
import Icon from './Icon';

export default function ThemeToggle({ isDark, onChange }) {
  const [saving, setSaving] = useState(false);
  const next = isDark ? 'LIGHT' : 'DARK';
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

  const handleClick = async () => {
    if (saving) return;
    setSaving(true);
    try { await onChange(next); }
    catch { /* silent — the icon simply doesn't flip, Settings shows errors */ }
    finally { setSaving(false); }
  };

  return (
    <button
      type="button"
      className="topbar-icon-btn topbar-theme-toggle"
      title={label}
      aria-label={label}
      disabled={saving}
      onClick={handleClick}
    >
      <Icon name={isDark ? 'sun' : 'moon'} size={17} />
    </button>
  );
}
